import { useState, type FormEvent } from "react";
import { useSession } from "./session.store.js";

/**
 * L'ecran de connexion. Deux champs, un bouton, un message.
 *
 * Le message d'erreur vient du serveur et reste unique — « Identifiants
 * invalides » pour un login inconnu comme pour un mot de passe faux. Le front
 * ne cherche pas a etre plus precis : il ne sait rien de plus, et c'est voulu.
 */
export function Connexion(): JSX.Element {
  const connecter = useSession((magasin) => magasin.connecter);
  const erreur = useSession((magasin) => magasin.erreur);
  const [login, setLogin] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [enCours, setEnCours] = useState(false);

  const soumettre = async (evenement: FormEvent) => {
    evenement.preventDefault();
    if (enCours) return;
    setEnCours(true);
    try {
      await connecter(login, motDePasse);
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div className="connexion">
      <form className="carte" onSubmit={(e) => void soumettre(e)}>
        <h1>HomeCAD</h1>
        <p className="sous-titre">CAO paramétrique auto-hébergée</p>

        <label htmlFor="login">Identifiant</label>
        <input
          id="login"
          name="username"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          required
          value={login}
          onChange={(event) => setLogin(event.target.value)}
        />

        <label htmlFor="motdepasse">Mot de passe</label>
        <input
          id="motdepasse"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          value={motDePasse}
          onChange={(event) => setMotDePasse(event.target.value)}
        />

        <button type="submit" disabled={enCours || login === "" || motDePasse === ""}>
          {enCours ? "Connexion…" : "Se connecter"}
        </button>

        {erreur !== undefined && (
          <p className="erreur" role="alert">
            {erreur}
          </p>
        )}

        <p className="note">
          Les comptes se créent sur le serveur, avec <code>make user-add</code>. Il n'y a pas
          d'inscription en ligne.
        </p>
      </form>
    </div>
  );
}
